// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3npi8","col":"styles_col__2DQY9"};